export default __webpack_public_path__ + "static/media/applewallet.f6faa1e6.svg";